'use client'

import { useLogout, usePrivy } from '@privy-io/react-auth'
import { useChains, useDisconnect } from 'wagmi'
import { ConnectorName } from 'wallet'
import { useUserContext } from 'src/contexts/user'
import { useChain } from '@azuro-org/sdk'
import { sendGTMEvent } from '@next/third-parties/google'
import { useRouter } from 'next/navigation'
import {
  useAAWalletClient,
  useAccount,
} from '@azuro-org/sdk-social-aa-connector'

export const useWallet = () => {
  const route = useRouter()
  const { authenticated, ready, user } = usePrivy()
  const { logoutUser, currentUser } = useUserContext()
  const { disconnect } = useDisconnect()
  const { logout } = useLogout()
  const { setAppChainId } = useChain()

  const {
    address,
    connector,
    isConnected,
    isConnecting,
    isReconnecting,
    chain,
    chainId,
    isAAWallet,
  } = useAccount()

  const logoutApp = async () => {
    sendGTMEvent({
      event: 'logout_completed',
      user_id: currentUser?.id,
      login_toolkit: 'privy',
      wallet_address: user ? user?.smartWallet?.address : address,
    })
    logoutUser()
    logout()
    disconnect()
    setAppChainId(137)
    route.refresh()
  }

  const chains = useChains()
  const aaWalletClient = useAAWalletClient()

  const isWalletConnect = connector?.name === ConnectorName.WalletConnect

  // const isAAWallet = connector?.name === ConnectorName.Privy

  return {
    account: isAAWallet
      ? user?.smartWallet?.address || address
      : user?.wallet?.address || address,
    connector,
    aaWalletClient,
    chain,
    chains,
    chainId,
    isConnected,
    isConnecting,
    isReconnecting: isReconnecting || (authenticated && !address),
    isWalletConnect,
    isAAWallet,
    isReady: Boolean(address && !Boolean(user?.id)) || ready,
    logoutApp,
  }
}
